export const REDIRECT_AUTHENTICATED_PATH = '/user/battery-incentive'
